export default "__VITE_ASSET__CEZb6JkG__"